// Trading Dashboard Statistics Component
export default {
  // Transfer In Section
  transferIn: "Transfer In",
  earliestTransferIn: "Earliest Transfer In:",

  // Transfer Out Section
  transferOut: "Transfer Out",
  latestTransferOut: "Latest Transfer Out:",

  // Statistics Labels
  transactionCount: "Transaction Count",
  transactionAmount: "Transaction Amount",
  counterparties: "Counterparties",

  // Units
  times: "times",
  tenThousand: "10k",
  units: "",
};
